{
  "firstName": "Nombre",
  "middleName": "Segundo nombre",
  "lastName": "Apellido",
  "dateOfBirth": "Fecha de nacimiento",
  "primaryEmail": "Correo electrónico",
  "phone": "Teléfono",
  "physicalAddress": "Dirección física",
  "mailingAddress": "Dirección postal",
  "alternateAddress": "Dirección alternativa",
  "inProvinceSince": "En la provincia desde",
  "gender": "Género",
  "language": "Idioma",
  "maritalStatus": "Estado civil",
  "numberOfDependents": "Número de dependientes",
  "citizenships": "Ciudadanías",
  "countryOfTaxResidence": "País de residencia fiscal",
  "taxId": "Identificación fiscal",
  "taxIdType": "Tipo de identificación fiscal",
  "taxIdDisclosed": "Identificación fiscal divulgada",
  "taxIdExists": "Identificación fiscal existente",
  "sinExists": "SIN existente",
  "taxNumber": "Número fiscal",
  "spouseTaxId": "Identificación fiscal del cónyuge",
  "spouseTaxIdType": "Tipo de identificación fiscal del cónyuge",
  "spouseTaxIdDisclosed": "Identificación fiscal del cónyuge divulgada",
  "employmentStatus": "Estado de empleo",
  "jobTitle": "Cargo",
  "companyType": "Tipo de empresa",
  "employerName": "Nombre del empleador",
  "employerCompanyAddress": "Dirección del empleador",
  "studentAreaOfStudy": "Área de estudio",
  "employmentSituation": "Situación laboral",
  "employmentSituationOtherDescription": "Situación laboral (otro)",
  "annualIncomeCents": "Ingreso anual",
  "annualIncomeStr": "Ingreso anual",
  "financialLiquidAssetsCents": "Activos líquidos",
  "financialFixedAssetsCents": "Activos fijos",
  "totalDebtCents": "Deuda total",
  "annualDebtPaymentsCents": "Pagos anuales de deuda",
  "sourceOfWealth": "Fuente de riqueza",
  "sourceOfFunds": "Fuente de fondos",
  "sourceOfWealthOtherDescription": "Fuente de riqueza (otro)",
  "sourceOfFundsOtherDescription": "Fuente de fondos (otro)",
  "debtAssociated": "Deuda asociada",
  "uniqueCircumstances": "Circunstancias particulares",
  "spouseFirstName": "Nombre del cónyuge",
  "spouseLastName": "Apellido del cónyuge",
  "spouseAnnualIncomeCents": "Ingreso anual del cónyuge",
  "trustedContactPerson": "Persona de confianza",
  "entityName": "Nombre de la entidad",
  "typeOfTrust": "Tipo de fideicomiso",
  "establishedDate": "Fecha de constitución",
  "registrationNumber": "Número de registro",
  "countryOfRegistration": "País de registro",
  "investmentKnowledge": "Conocimiento de inversiones",
  "riskQuestion1": "Pregunta de riesgo 1",
  "riskQuestion2": "Pregunta de riesgo 2",
  "foreignTaxInformation": "Información fiscal extranjera",
  "fatcaStatus": "Estado FATCA",
  "fatcaStatusOtherDescription": "Estado FATCA (otro)",
  "preferredMethodOfCommunication": "Método de comunicación preferido",
  "iDCheckCompleted": "Verificación de identidad completada",
  "iDCheckRetrigger": "Reverificación de identidad",
  "iDVerified": "Identidad verificada",
  "complianceState": "Estado de cumplimiento",
  "payTaxesOutsideCanada": "Paga impuestos fuera de Canadá"
}
